// extracted by mini-css-extract-plugin
module.exports = {"productListContainer":"product-list_productListContainer__IITFU","productListItem":"product-list_productListItem__1undm"};